import { render, staticRenderFns } from "./warning-feedback.vue?vue&type=template&id=186ab3dc&scoped=true&"
import script from "./warning-feedback.vue?vue&type=script&lang=js&"
export * from "./warning-feedback.vue?vue&type=script&lang=js&"
import style0 from "./warning-feedback.vue?vue&type=style&index=0&id=186ab3dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186ab3dc",
  null
  
)

export default component.exports